import { setFontVariant } from "@similarweb/styles";
import { translate } from "app/filters/i18nFilter";
import type { FC } from "react";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

const DeprecatedWidgetContainer = styled(CenteredFlexColumn)`
    margin-top: 56px;
    width: 100%;
`;

const DeprecatedWidgetTitle = styled.div`
    ${setFontVariant("h3")}
    margin-bottom: 8px;
    @media (max-width: 1540px) {
        ${setFontVariant("h5")}
    }
`;

const DeprecatedWidgetSubtitle = styled.div`
    ${setFontVariant("body2")}
    @media (max-width: 1540px) {
        ${setFontVariant("sectionTitle")}
    }
`;

interface IDeprecatedWidgetComponent {
    title: string;
    subtitle?: string;
}

export const DeprecatedWidgetComponent: FC<IDeprecatedWidgetComponent> = (props) => {
    const {
        title = translate("dashboards.widget.deprecated.title"),
        subtitle = translate("dashboards.widget.deprecated.subtitle"),
    } = props;
    return (
        <DeprecatedWidgetContainer>
            <DeprecatedWidgetTitle>{title}</DeprecatedWidgetTitle>
            <DeprecatedWidgetSubtitle>{subtitle}</DeprecatedWidgetSubtitle>
        </DeprecatedWidgetContainer>
    );
};
